import { io, Socket } from 'socket.io-client';

import { environmentVars } from '../api/variables/environment';

class WebSocketClient {
	private socket: Socket | null = null;
	// O backend usa o namespace padrão '/'
	private readonly baseURL: string;

	constructor() {
		this.baseURL = environmentVars.core.api || 'http://localhost:4000';
	}

	connect(token: string): Socket | null {
		if (this.socket?.connected) {
			return this.socket;
		}

		try {
			// Conectar ao namespace padrão '/'
			// O backend usa o namespace padrão e filtra por empresa_id usando rooms
			const url = this.baseURL;

			// socket.io-client 4.x suporta query como objeto ou string
			this.socket = io(url, {
				query: {
					token: token,
				},
				transports: ['websocket', 'polling'],
				reconnection: true,
				reconnectionDelay: 1000,
				reconnectionDelayMax: 5000,
				reconnectionAttempts: 5,
				forceNew: true,
				upgrade: true,
			});

			this.socket.on('connect', () => {
				// Conexão estabelecida silenciosamente
			});

			this.socket.on('disconnect', () => {
				// Desconexão silenciosa
			});

			this.socket.on('connect_error', error => {
				console.error('[WebSocket Client] ❌ Connection error:', error);
				console.error('[WebSocket Client] Error details:', {
					message: error.message,
					name: error.name,
				});
			});

			this.socket.on('error', error => {
				console.error('[WebSocket Client] Socket error:', error);
			});

			// Log quando a conexão estiver pronta
			this.socket.on('connect_timeout', () => {
				console.warn('[WebSocket Client] Connection timeout');
			});

			// Eventos de reconnection (silenciosos)
			this.socket.on('reconnect', () => {
				// Reconectado silenciosamente
			});

			this.socket.on('reconnect_attempt', () => {
				// Tentativa de reconexão silenciosa
			});

			this.socket.on('reconnect_error', error => {
				console.error('[WebSocket Client] Reconnection error:', error);
			});

			this.socket.on('reconnect_failed', () => {
				console.error('[WebSocket Client] Reconnection failed');
			});

			return this.socket;
		} catch (error) {
			console.error(
				'[WebSocket Client] Error creating WebSocket connection:',
				error
			);
			return null;
		}
	}

	disconnect(): void {
		if (this.socket) {
			this.socket.disconnect();
			this.socket = null;
		}
	}

	isConnected(): boolean {
		return this.socket?.connected ?? false;
	}

	getSocket(): Socket | null {
		return this.socket;
	}

	on(event: string, callback: (...args: unknown[]) => void): void {
		if (this.socket) {
			this.socket.on(event, callback);
		}
	}

	off(event: string, callback?: (...args: unknown[]) => void): void {
		if (this.socket) {
			if (callback) {
				this.socket.off(event, callback);
			} else {
				this.socket.off(event);
			}
		}
	}
}

export const websocketClient = new WebSocketClient();
